<template>
  <div>
    <DashboardTiles
      :tiles="filteredTiles"
      :currentUser="getCurrentUser"
      :currentCompany="getUserCompany"
    ></DashboardTiles>
  </div>
</template>

<script>
import helpersjs from "@/plugins/helpers";
import DashboardTiles from "baron-vue-dashboard-tiles";

export default {
  props: ["tiles"],
  components: { DashboardTiles },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    isLegalPractice() {
      return this.$store.getters.isLegalPractice;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
  },
  watch: {
    tiles(newTiles) {
      this.filteredTiles = newTiles;
    },
  },
  mounted() {
    this.filteredTiles = this.tiles;
  },
  data: () => ({
    filteredTiles: [],
  }),
};
</script>

<style></style>
